import { cn } from '@/lib/utils';

import { MenuGroup, MenuGroupProps } from './MenuGroup';

export function MenuAccordionContent({
  groups,
  onLinkClick,
}: { groups: MenuGroupProps[] } & {
  onLinkClick?: (
    params: { title: string } | { url: string; keepMenuOpen?: boolean }
  ) => void;
}) {
  return (
    <ul className='overflow-hidden'>
      {groups
        .filter((group) => group.type !== 'extra')
        .map((group, i) => (
          <li
            key={i}
            className={cn(
              'h-full origin-left',
              group.type === 'main' && 'flex-grow'
            )}
          >
            <MenuGroup
              key={i}
              type={group.type}
              lists={group.lists}
              onLinkClick={onLinkClick}
            />
          </li>
        ))}
    </ul>
  );
}
